import React from 'react'
import Typical from 'react-typical'
import "./Profile.css"

import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init({
    offset: 180, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 2000, // values from 0 to 3000, with step 50ms
    easing: 'ease', // default easing for AOS animations
    once: false, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
    anchorPlacement: 'top-bottom'
});




export default function Profile() {
    return (
        <div>
            <div className="profile-container">
                {/* <div className="navBar"></div> */}

                <div className="profile-details">

                    <div className="intro" data-aos="zoom-in-right"> Hi, this is </div> <br />
                    <div className="name" data-aos="zoom-in">Arindam Halder</div>


                    <div className="role">
                        <Typical loop={Infinity} steps={[
                            "Full Stack Web Developer", 2000,
                            "MERN Stack Web Developer", 2000,
                            "Programmer", 2000
                        ]} />
                    </div>

                    <div className="mobile-dp">
                        <a href="/">
                            <div className="profile-photo-bg" data-aos="zoom-in"></div></a>
                        <div className="socialMediaIcons">
                            <a href="https://www.facebook.com/arindam363" target="_blank" rel="noopener noreferrer"> <i className="fa fa-facebook-square" data-aos="fade-right" id="fb"></i> </a>
                            <a href="https://www.instagram.com/arindam369/" target="_blank" rel="noopener noreferrer"> <i className="fa fa-instagram" data-aos="fade-right" id="insta"></i> </a>
                            <a href="https://twitter.com/Arindam87777" target="_blank" rel="noopener noreferrer"> <i className="fa fa-twitter-square" data-aos="flip-left" id="twitter"></i> </a>
                            <a href="https://www.linkedin.com/in/arindam369/" target="_blank" rel="noopener noreferrer"> <i className="fa fa-linkedin" data-aos="fade-left" id="linkedin"></i> </a>
                            <a href="https://github.com/arindam369" target="_blank" rel="noopener noreferrer"> <i className="fa fa-github" data-aos="fade-left" id="github"></i> </a>
                        </div>
                    </div>
                    
                    <p className="interests" data-aos="zoom-in">
                        I am an aspiring developer and an IT undergrad in Jadavpur University. I love to code. I am passionate about what I do. Instead of just working to make a paycheck, I work because I love what I do.

                    </p>


                    <div className="button-box">
                        <div className="mailMe">
                            <a href="mailto:halderarindam10000@gmail.com">
                                <button data-aos="zoom-in">Mail Me</button>
                            </a>
                        </div>
                        <div className="resume">
                            <a href="https://d1pwl9tuq1iz8h.cloudfront.net" target="_blank" rel="noopener noreferrer">
                                <button data-aos="zoom-in">Get Resume</button>
                            </a>
                            {/* <a href={require("./../../static/Arindam_Resume.pdf")}>
                                <button data-aos="zoom-in">Get Resume</button>
                            </a> */}
                        </div>
                    </div>
                </div>

                <div className="dp">
                    <a href="/">
                        <div className="profile-photo-bg" data-aos="zoom-in"></div></a>
                    <div className="socialMediaIcons">
                        <a href="https://www.facebook.com/arindam363" target="_blank" rel="noopener noreferrer"> <i className="fa fa-facebook-square" data-aos="fade-right" id="fb"></i> </a>
                        <a href="https://www.instagram.com/arindam369/" target="_blank" rel="noopener noreferrer"> <i className="fa fa-instagram" data-aos="fade-right" id="insta"></i> </a>
                        <a href="https://twitter.com/Arindam87777" target="_blank" rel="noopener noreferrer"> <i className="fa fa-twitter-square" data-aos="flip-left" id="twitter"></i> </a>
                        <a href="https://www.linkedin.com/in/arindam369/" target="_blank" rel="noopener noreferrer"> <i className="fa fa-linkedin" data-aos="fade-left" id="linkedin"></i> </a>
                        <a href="https://github.com/arindam369" target="_blank" rel="noopener noreferrer"> <i className="fa fa-github" data-aos="fade-left" id="github"></i> </a>
                    </div>
                </div>


            </div>
        </div>
    )
}
